import React from "react";
import { View, Text } from "@react-pdf/renderer";
import TableRow from "./TableRow";
import { ALARMS_TABLE_STRINGS } from "constants/constantStrings";
import styles from "./ItemTable.styles";

const ItemsTable = ({ data }) => (
  <View style={styles.tableContainer} break={true} wrap={false}>
    <View style={styles.header}>
      <Text style={styles.headerAlarmId}>{ALARMS_TABLE_STRINGS.headerAlarmID}</Text>
      <Text style={styles.headerDescription}>{ALARMS_TABLE_STRINGS.headerAlarmDesc}</Text>
    </View>
    <TableRow items={data} />
  </View>
);

export default ItemsTable;
